/**
 * File: src/data/ant-clash-config-default.js
 * Mô tả: Cấu hình mặc định cho Ant Clash đồng bộ từ progression_v3.json v1.0.339.
 * Liên quan: src/validation/ant-clash-config-schema.js, src/services/admin-config-service.js
 */

export const defaultAntClashConfig = {
  "testing_profile": {
    "enabled": false,
    "starting_resin": 1000000,
    "unlock_all_units": true,
    "unlock_all_maps": true
  },
  "unit_progression": {
    "worker_move_speed": 2.0,
    "dispatch_rate_multiplier": 1.5,
    "nest_production_rate_multiplier": 0.5,
    "champion": {
      "normal_units_before_champion_by_nest_level": [
        0,
        10,
        8,
        6,
        4
      ],
      "damage_multiplier": 1.5,
      "hp_multiplier": 3.0,
      "move_speed_multiplier": 1.0,
      "visual_scale_multiplier": 1.2
    },
    "level_scaling": {
      "normal_multiplier": 1.1,
      "form_multiplier": 1.3,
      "form_levels": [
        5,
        10,
        15
      ]
    },
    "unit_cost_multiplier_per_id": 1.1,
    "worker_upgrade_costs": [
      250,
      300,
      350,
      420,
      490,
      590,
      690,
      820,
      980,
      1160,
      1370,
      1630,
      1930,
      2290,
      2710,
      3220,
      3810,
      4520,
      5400
    ],
    "unit_card_upgrade_curve": {
      "from_level": 1,
      "to_level": 19,
      "from_cards": 2,
      "to_cards": 200
    },
    "unit_unlock_costs": [
      0,
      600,
      900,
      1300,
      1800,
      2500,
      3400,
      4500,
      5900,
      7600,
      9700,
      12300
    ],
    "unlock_gates": [
      {
        "unit_id": 2,
        "chapter_id": 1,
        "level_index": 3
      },
      {
        "unit_id": 3,
        "chapter_id": 1,
        "level_index": 6
      },
      {
        "unit_id": 4,
        "chapter_id": 1,
        "level_index": 9
      },
      {
        "unit_id": 5,
        "chapter_id": 2,
        "level_index": 3
      },
      {
        "unit_id": 6,
        "chapter_id": 2,
        "level_index": 7
      },
      {
        "unit_id": 7,
        "chapter_id": 3,
        "level_index": 1
      },
      {
        "unit_id": 8,
        "chapter_id": 3,
        "level_index": 5
      },
      {
        "unit_id": 9,
        "chapter_id": 3,
        "level_index": 9
      },
      {
        "unit_id": 10,
        "chapter_id": 4,
        "level_index": 4
      },
      {
        "unit_id": 11,
        "chapter_id": 4,
        "level_index": 8
      },
      {
        "unit_id": 12,
        "chapter_id": 5,
        "level_index": 3
      }
    ],
    "skill_costs": {
      "fire": [
        1535,
        1765,
        2030,
        2335,
        2685,
        3090,
        3555,
        4085,
        4700
      ],
      "standard": [
        3070,
        3530,
        4060,
        4670,
        5370,
        6180,
        7110,
        8170,
        9400
      ]
    },
    "skill_effects": {
      "fire_duration_seconds": {
        "min": 2.0,
        "max": 10.0
      },
      "brood_production_bonus": {
        "min": 0.5,
        "max": 1.5
      },
      "war_damage_hp_bonus": {
        "min": 0.2,
        "max": 0.7
      },
      "mana_core": {
        "max_mana_min": 60,
        "max_mana_max": 200,
        "regen_per_second_min": 2.0,
        "regen_per_second_max": 5.0
      },
      "global_duration_seconds": 15.0
    },
    "units": [
      {
        "id": 1,
        "damage": 10.0,
        "hp": 100,
        "spawn_interval": 1.0,
        "move_speed": 1.0
      },
      {
        "id": 2,
        "damage": 14.8,
        "hp": 149,
        "spawn_interval": 2.0,
        "move_speed": 0.5
      },
      {
        "id": 3,
        "damage": 12.0,
        "hp": 242,
        "spawn_interval": 2.4,
        "move_speed": 0.4
      },
      {
        "id": 4,
        "damage": 11.0,
        "hp": 91,
        "spawn_interval": 0.75,
        "move_speed": 1.2
      },
      {
        "id": 5,
        "damage": 25.0,
        "hp": 88,
        "spawn_interval": 1.5,
        "move_speed": 1.1
      },
      {
        "id": 6,
        "damage": 9.0,
        "hp": 90,
        "spawn_interval": 0.5,
        "move_speed": 0.8
      },
      {
        "id": 7,
        "damage": 11.0,
        "hp": 113,
        "spawn_interval": 0.7,
        "move_speed": 0.7
      },
      {
        "id": 8,
        "damage": 40.0,
        "hp": 88,
        "spawn_interval": 1.8,
        "move_speed": 0.6
      },
      {
        "id": 9,
        "damage": 12.0,
        "hp": 197,
        "spawn_interval": 1.1,
        "move_speed": 0.5
      },
      {
        "id": 10,
        "damage": 23.0,
        "hp": 92,
        "spawn_interval": 0.9,
        "move_speed": 1.2
      },
      {
        "id": 11,
        "damage": 51.0,
        "hp": 71,
        "spawn_interval": 1.4,
        "move_speed": 1.2
      },
      {
        "id": 12,
        "damage": 26.0,
        "hp": 71,
        "spawn_interval": 0.65,
        "move_speed": 1.2
      }
    ],
    "enemy_campaign_progression": {
      "power_formula": "damage * hp / spawn_interval",
      "expected_growth_per_stage": 1.1087,
      "final_profile": {
        "unit_id": 12,
        "unit_level": 20
      },
      "chapter_profiles": [
        [
          {
            "unit_id": 2,
            "unit_level": 1
          },
          {
            "unit_id": 2,
            "unit_level": 2
          },
          {
            "unit_id": 3,
            "unit_level": 2
          },
          {
            "unit_id": 2,
            "unit_level": 3
          },
          {
            "unit_id": 3,
            "unit_level": 3
          },
          {
            "unit_id": 2,
            "unit_level": 4
          },
          {
            "unit_id": 3,
            "unit_level": 4
          },
          {
            "unit_id": 4,
            "unit_level": 4
          },
          {
            "unit_id": 2,
            "unit_level": 5
          },
          {
            "unit_id": 2,
            "unit_level": 5
          },
          {
            "unit_id": 2,
            "unit_level": 5
          }
        ],
        [
          {
            "unit_id": 4,
            "unit_level": 5
          },
          {
            "unit_id": 4,
            "unit_level": 5
          },
          {
            "unit_id": 5,
            "unit_level": 5
          },
          {
            "unit_id": 4,
            "unit_level": 6
          },
          {
            "unit_id": 5,
            "unit_level": 6
          },
          {
            "unit_id": 4,
            "unit_level": 7
          },
          {
            "unit_id": 5,
            "unit_level": 7
          },
          {
            "unit_id": 4,
            "unit_level": 8
          },
          {
            "unit_id": 4,
            "unit_level": 9
          },
          {
            "unit_id": 5,
            "unit_level": 9
          },
          {
            "unit_id": 6,
            "unit_level": 9
          }
        ],
        [
          {
            "unit_id": 7,
            "unit_level": 9
          },
          {
            "unit_id": 8,
            "unit_level": 9
          },
          {
            "unit_id": 9,
            "unit_level": 9
          },
          {
            "unit_id": 6,
            "unit_level": 10
          },
          {
            "unit_id": 6,
            "unit_level": 10
          },
          {
            "unit_id": 7,
            "unit_level": 10
          },
          {
            "unit_id": 8,
            "unit_level": 10
          },
          {
            "unit_id": 7,
            "unit_level": 11
          },
          {
            "unit_id": 8,
            "unit_level": 11
          },
          {
            "unit_id": 7,
            "unit_level": 12
          },
          {
            "unit_id": 8,
            "unit_level": 12
          }
        ],
        [
          {
            "unit_id": 9,
            "unit_level": 12
          },
          {
            "unit_id": 10,
            "unit_level": 12
          },
          {
            "unit_id": 9,
            "unit_level": 13
          },
          {
            "unit_id": 8,
            "unit_level": 14
          },
          {
            "unit_id": 10,
            "unit_level": 14
          },
          {
            "unit_id": 8,
            "unit_level": 15
          },
          {
            "unit_id": 8,
            "unit_level": 15
          },
          {
            "unit_id": 8,
            "unit_level": 15
          },
          {
            "unit_id": 8,
            "unit_level": 15
          },
          {
            "unit_id": 9,
            "unit_level": 15
          },
          {
            "unit_id": 9,
            "unit_level": 16
          }
        ],
        [
          {
            "unit_id": 10,
            "unit_level": 16
          },
          {
            "unit_id": 11,
            "unit_level": 16
          },
          {
            "unit_id": 12,
            "unit_level": 16
          },
          {
            "unit_id": 11,
            "unit_level": 17
          },
          {
            "unit_id": 12,
            "unit_level": 17
          },
          {
            "unit_id": 11,
            "unit_level": 18
          },
          {
            "unit_id": 12,
            "unit_level": 18
          },
          {
            "unit_id": 11,
            "unit_level": 19
          },
          {
            "unit_id": 12,
            "unit_level": 19
          },
          {
            "unit_id": 11,
            "unit_level": 20
          },
          {
            "unit_id": 12,
            "unit_level": 20
          }
        ]
      ]
    }
  },
  "economy": {
    "starting_currency": 1000,
    "first_star_reward_multiplier": 1.0,
    "second_star_reward_multiplier": 1.0,
    "third_star_reward_multiplier": 1.0,
    "replay_reward_multiplier": 0.5,
    "defeat_reward_multiplier": 0.179,
    "two_star_replay_multiplier": 1.1,
    "three_star_replay_multiplier": 1.25,
    "game_over_reward_multiplier": 3.0,
    "match_card_rewards": {
      "first_level_cards": 1,
      "final_level_cards": 10,
      "chapter_count": 5,
      "levels_per_chapter": 11,
      "replay_cards": 1,
      "replay_card_multiplier": 0.336
    },
    "chapter_rewards": [
      [
        60,
        70,
        80,
        85,
        95,
        110,
        120,
        130,
        150,
        190,
        230
      ],
      [
        145,
        160,
        175,
        190,
        210,
        230,
        255,
        280,
        305,
        390,
        470
      ],
      [
        295,
        320,
        350,
        385,
        420,
        460,
        505,
        555,
        610,
        775,
        930
      ],
      [
        580,
        635,
        700,
        760,
        835,
        910,
        995,
        1090,
        1200,
        1530,
        1840
      ],
      [
        1150,
        1260,
        1380,
        1510,
        1660,
        1810,
        1980,
        2170,
        2380,
        3000,
        3600
      ]
    ]
  }
};
